<template>
  <div class="main-container container-fh__content p-trial-period-expired" style="padding: 0px;">
    <img
      src="/static/img/modal/1.svg"
      alt
      class="p-trial-period-expired__image"
      width="100px"
      style="margin-top: 50px"
    />
    <div class="col-md-8" v-if="reqSuccess == true">
      <div class="p-trial-period-expired__desc">Your installation schedule has been submitted!</div>
      <div class="panel-body" style="text-align: center !important;">
        You will recieve a notification when granted
        Thanks.
      </div>
    </div>
    <div class="col-md-8" v-if="reqSuccess == false">
      <div class="widget widget-alpha widget-alpha--color-amaranth">
        <div>
          <div
            class="widget-alpha__amount"
          >{{ installationData.user? `${installationData.user.firstName} ${installationData.user.lastName}`: `-`}}</div>
          <div
            class="widget-alpha__description"
          >{{ installationData.user?`${installationData.user.email} ` : `-` }}</div>
          <div
            class="widget-alpha__description"
          >{{ installationData.user ? ` ${installationData.deviceType.name}`:`-` }}</div>
          <div
            class="widget-alpha__description"
            style="font-weight: bold;"
          >{{ ` ${installationData.paymentModel}` }}</div>
        </div>
        <span class="widget-alpha__icon fa fa-info"></span>
      </div>

      <el-card class="box-card widget">
        <div slot="header" class="widget_header">
          <span class="widget_header__title">Installation Component Configuration</span>
        </div>
        <!-- {{instalationPackageConfig}} -->
        <vue-good-table
          :columns="columns"
          :rows="instalationPackageConfig"
          styleClass="table table-striped col-md-12"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'quantity'">
              <el-input-number
                v-model="instalationPackageConfig[props.row.originalIndex]['quantity']"
                :min="1"
              ></el-input-number>
            </span>
            <span
              v-if="props.column.field == 'componentType.name'"
              style="text-transform: capitalize; font-weight: bold;"
            >{{ props.row.componentType.name }}</span>
            <!-- <span v-else>{{props.row[props.column.field]}}</span> -->
          </template>
        </vue-good-table>
        <!-- {{installationData.deviceType.packageComponents}} -->
      </el-card>
      <!-- <div class="row" style="background: #ecf2f6;">
        <h3 class="p-trial-period-expired__desc text-center">Add Component</h3>
        <div class="col-md-12" style=" display: flex;">
          <b-form-select
            v-model="componentId"
            :options="componentOptions"
            id="componentName"
            @change="fetchComponentTypes"
            placeholder="Select Component"
            class="mb-3"
            style="text-transform: capitalize !important"
          ></b-form-select>
          <b-form-select
            v-model="componentTypeId"
            :options="componentTypeOptions"
            id="componentType"
            placeholder="Select Component"
            class="mb-3"
            style="text-transform: capitalize !important"
          ></b-form-select>
          <input
            type="number"
            class="form-control form-control-lg"
            id="item-qty"
            v-model.number="qty"
            value="1"
            style="width:70px"
            min="1"
            placeholder="Qty"
          />
          <b-button size @click="addInventory" style="margin-bottom: 12px;">
            Add &nbsp;
            <span class="fa fa-plus"></span>
          </b-button>
        </div>
      </div>-->
      <div class="p-trial-period-expired__upgrade" style="flex-flow: column;">
        <div class="form-group">
          <button
            class="btn btn-info btn-lg btn-block btn-rounded"
            type="button"
            @click="submitRequest"
          >Submit Installation schedule</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Autocomplete from "../../utils/Autocomplete";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    Autocomplete
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      instalationPackageConfig: [],
      componentId: null,
      componentTypeId: null,
      componentForm: {
        componentId: null,
        componentTypeId: null,
        qty: 1
      },
      componentOptions: [
        {
          value: null,
          disabled: true,
          text: "Select component"
        }
      ],
      componentTypeOptions: [
        {
          value: null,
          disabled: true,
          text: "Select component type"
        }
      ],
      installationData: {
        typeOfBuilding: null,
        roofType: null,
        roofCondition: null,
        roofReadiness: null,
        roofAge: null,
        comment: null,
        createAt: null,
        deviceType: null,
        user: null
      },
      columns: [
        /*    {
          label: "SN",
          field: "sn",
          type: "date"
        }, */
        {
          label: "Component",
          field: "componentType.name",
          filterable: true
        },
        {
          label: "Qty",
          field: "quantity",
          filterable: true
        }
      ],
      rows: [],
      reqSuccess: false
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDummy",
      "getDevices",
      "getUserSession"
    ])
  },
  methods: {
    validateRequestForm() {
      for (let [field, value] of Object.entries(this.requestForm)) {
        if (value === null || value === "") {
          return "Please fill all fields!";
        }
      }
      return true;
    },
    fetchComponentTypes(selectedCompId) {
      if (selectedCompId !== null) {
        const context = this;
        const HTTP = this.$httpUtils.instance;
        const url = `/components/${selectedCompId}/componentTypes`;
        HTTP.get(url)
          .then(response => {
            const componentList = response.data;
            componentList.filter(x => {
              x.value = x.id;
              x.text = x.name;
            });
            componentList.unshift({
              value: null,
              disabled: true,
              text: "Please component type"
            });

            context.componentTypeOptions = componentList;
            context.componentTypeId = null;
          })
          .catch(error => {
            console.log("error", error);
          });
      }
    },
    removeData(index) {
      let name = this.rows.filter(x => x.componentId == index.componentId);
      this.rows.splice(index.originalIndex, 1);
      this.componentOptions.splice(1, 0, {
        id: index.componentId,
        value: index.componentId,
        text: index.component,
        name: index.component
      });
    },
    fetchComponents() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.get("/components/", {})
        .then(components => {
          const componentFetch = components.data;
          componentFetch.filter(x => {
            x.value = x.id;
            x.text = x.name;
          });
          componentFetch.unshift({
            value: null,
            disabled: true,
            text: "Select Component"
          });
          container.componentOptions = componentFetch;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    submitRequest() {
      var requestId = this.$route.params.id * 1;
      let pcConfig = this.instalationPackageConfig.map(x => ({
        quantity: x.quantity,
        componentTypeId: x.componentId,
        deviceRequestId: requestId
      }));
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.post("/installation_components", pcConfig).then(response => {
        const componentsResponse = response.data;
        if (componentsResponse) {
          HTTP.patch(`/device_requests/${requestId}`, {
            status: 2
          }).then(data => {
            this.showSuccessMsg({ message: "Installation Approved" });
            setTimeout(() => {
              container.$router.push({
                name: "instalationList"
              });
            }, 500);
          });
        }
      });
    },
    addInventory() {
      const conName = this.getComponentName(
        document.getElementById("componentName").value
      );
      const conType = this.getComponentTypeName(
        document.getElementById("componentType").value
      );
      let itemqty = document.getElementById("item-qty").value;
      itemqty = itemqty == "" ? 1 : itemqty;
      this.rows.push({
        deviceRequestId: this.$route.params.id,
        componentTypeId: document.getElementById("componentType").value,
        componentId: document.getElementById("componentName").value,
        component: conName,
        spec: conType,
        qty: itemqty,
        quantity: itemqty
      });
      this.componentOptions.splice(
        document.getElementById("componentName").selectedIndex,
        1
      );
      this.componentTypeOptions.splice(
        document.getElementById("componentType").selectedIndex,
        1
      );
      document.getElementById("componentName").selectedIndex = 0;
      document.getElementById("componentType").selectedIndex = 0;
    },
    getComponentName(param) {
      return this.componentOptions.filter(x => x.value == param)[0].name;
    },
    getComponentTypeName(param) {
      return this.componentTypeOptions.filter(x => x.value == param)[0].name;
    },
    formatDate(date) {
      var date = new Date(date); //or your date here
      return (
        date.getFullYear() + "/" + date.getMonth() + 1 + "/" + date.getDate()
      );
    },
    formatTime(date) {
      var date = new Date(date); //or your date here
      return (
        date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds()
      );
    },
    fetchData(d) {
      var requestId = this.$route.params.id;
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.get(
        "/device_requests/" +
          d +
          `?filter={"include": ["user","transactionHistories", {"deviceType": { "packageComponents": "componentType" }}]}`,
        {}
      )
        .then(components => {
          const componentFetch = components.data;
          this.installationData = componentFetch;
          return this.installationData.deviceType.packageComponents;
        })
        .then(packageComponents => {
          this.instalationPackageConfig = packageComponents.map(x => ({
            quantity: x.quantity,
            componentTypeId: x.componentId,
            deviceRequestId: requestId,
            ...x
          }));
        });
    }
  },
  mounted() {
    this.fetchData(this.$route.params.id);
    this.fetchComponents();
  }
};
</script>

<style>
.section-container {
  border-radius: 7px;
  background: #fff;
  -webkit-box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  margin-bottom: 1.875rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  min-height: 200px;
}

.p-trial-period-expired__upgrade .form-group {
  width: 100%;
}

.custom-control-description {
  margin-left: 12px;
}

#__BVID__36___BV_label_,
#__BVID__40___BV_label_ {
  font-size: 13px !important;
}

.widget_box {
  min-height: auto !important;
}

.modal-header {
  border-bottom-left-radius: 50% 20%;
  border-bottom-right-radius: 50% 20%;
  background: #ecf2f6;
  color: #269af1;
  /* height: 100px; */
}

.custom-modal__body {
  padding: 40px;
  text-align: left;
}

.test-basic__format {
  font-size: 16px;
  color: #939daa;
}

.test-basic__format span {
  font-weight: 800;
  color: #269af1;
}

.p-trial-period-expired__desc {
  color: #269af1;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/instalation/addInstalation.vue